'use client';

import React from 'react';

import { useGetPrivacyAndPolicy } from '@/common/apis/dedicated-personal-page/get-privacy-and-policy.api';
import DedicatedPersonalPage from '@/common/components/dedicated-personal-page/dedicated-personal-page.component';
import Loading from '@/common/components/loading';

const PrivacyPolicies = () => {
  const { data, isLoading } = useGetPrivacyAndPolicy();

  if (isLoading) return <Loading />;

  const content = data?.data.content;

  return <DedicatedPersonalPage content={content} title="قوانین و مقررات" />;
};

export default PrivacyPolicies;
